import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { BodyPrimary, BodySecondary, HR, SubtitlePrimary } from '../Base';
import Modal from '../Modal';
import PromoFrameworkOne from './PromoFrameworkOne';
import PromoFrameworkTwo from './PromoFrameworkTwo';
import Spacing from '../Spacing';

import PromoAreaMobile from '../../assets/images/promo-area-mobile.png';
import PromoAreaDesktop from '../../assets/images/promo-area-desktop.png';
import IconChevronRight from '../../assets/svgs/chevron-right.svg';

const Container = styled.div`
  display: flex;
  align-items: center;
  height: ${p => p.theme.spacing(9)};
  color: ${p => p.theme.colours.white};
  background: url(${PromoAreaMobile}) no-repeat right,
    linear-gradient(
      to right,
      ${p => p.theme.colours.bright_blue},
      ${p => p.theme.colours.vivid_cyan}
    );
  ${p => p.theme.media.md`
    background: url(${PromoAreaDesktop}) no-repeat right, 
      linear-gradient(
        to right, 
        ${p => p.theme.colours.bright_blue}, 
        ${p => p.theme.colours.vivid_cyan}
      );
    `};
  padding: 0 ${p => p.theme.spacing(2)};
  border-radius: 4px;
  cursor: pointer;
`;

const StyledTitle = styled.div`
  text-align: center;
`;

const StyledPrimaryLiner = styled(BodyPrimary)`
  display: inline-block;
  margin-right: ${p => p.theme.spacing(1)};
`;

const StyledIconChevronRight = styled(IconChevronRight)`
  vertical-align: middle;
`;

const StyledModalContent = styled.div`
  text-align: center;
`;

const StyledFooter = styled(BodySecondary)`
  color: ${p => p.theme.colours.grey_600};
`;

const PromoArea = props => {
  const {
    primaryLiner,
    promotions,
    secondaryTitle,
    secondaryDescription,
    secondaryFooter
  } = props;

  const [openModal, setOpenModal] = useState(false);

  const PromoModal = () => {
    return (
      <Modal
        open={openModal}
        title={<StyledTitle>{secondaryTitle}</StyledTitle>}
        onClose={() => setOpenModal(false)}
      >
        <Spacing bottom={1}>
          <StyledModalContent>
            <Spacing bottom={3}>
              <BodySecondary>{secondaryDescription}</BodySecondary>
            </Spacing>
            <Spacing bottom={3}>
              <HR />
            </Spacing>
            {promotions.map((promotion, key) => {
              const { type, groupTitle, promos } = promotion;

              const AdditionComponent = () =>
                key !== promotions.length - 1 && (
                  <Spacing bottom={2}>
                    <SubtitlePrimary>+</SubtitlePrimary>
                  </Spacing>
                );

              return (
                <Fragment key={key}>
                  {Number(type) === 1 && (
                    <Fragment>
                      <PromoFrameworkOne promos={promos} />
                      <AdditionComponent />
                    </Fragment>
                  )}
                  {Number(type) === 2 && (
                    <Fragment>
                      <PromoFrameworkTwo
                        groupTitle={groupTitle}
                        promos={promos}
                      />
                      <AdditionComponent />
                    </Fragment>
                  )}
                </Fragment>
              );
            })}
            <Spacing top={6}>
              <StyledFooter>{secondaryFooter}</StyledFooter>
            </Spacing>
          </StyledModalContent>
        </Spacing>
      </Modal>
    );
  };

  return (
    <Fragment>
      <Container onClick={() => setOpenModal(true)}>
        <StyledPrimaryLiner>{primaryLiner}</StyledPrimaryLiner>
        <StyledIconChevronRight size={8} />
      </Container>
      <PromoModal />
    </Fragment>
  );
};

PromoArea.propTypes = {
  /** Sets the primary liner of the promotion */
  primaryLiner: PropTypes.string,
  promotions: PropTypes.array,
  secondaryTitle: PropTypes.string,
  secondaryDescription: PropTypes.string,
  secondaryFooter: PropTypes.string
};

export default PromoArea;
